var CustomSnackBarComponent = /** @class */ (function () {
    function CustomSnackBarComponent(data) {
        this.data = data;
        this.message = data.message;
        this.type = data.type;
        this.action = data.action || null;
        this.optionsFromIcons = {
            success: 'check_circle',
            copied: 'content_copy',
            error: 'error',
            info: 'info',
            custom: data.icon
        };
        this.icon = this.optionsFromIcons[this.type];
    }
    return CustomSnackBarComponent;
}());
export { CustomSnackBarComponent };
